import { FatorMoeda } from './../../model/geral/fatorMoeda';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { AutoRegisterService } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})
@AutoRegisterService()
export class FatorMoedaService extends GenericService<FatorMoeda>{

  private fatorSubject = new BehaviorSubject<number>(1);
  fator$ = this.fatorSubject.asObservable();
  private fator: number; // Adicione essa propriedade

  constructor(http: HttpClient) {
    super(http);
    super.initResource("fatormoeda")
  }

  getFatorMoedaMaisRecente(idCompany: number): Observable<FatorMoeda> {
    let idMoedaLocal = 2;
    const url = `${this.url}/recente/${idCompany}/${idMoedaLocal}`;
    return this.http.get<FatorMoeda>(url);
  }

  getAllFatorMoeda(idCompany: number): Observable<FatorMoeda[]> {
    const url = `${this.url}/fator/${idCompany}`;
    return this.http.get<FatorMoeda[]>(url);
  }

  atualizarFator(fator: number) {
    this.fatorSubject.next(fator);
    this.fator = fator; // Atualiza o fator internamente no serviço
    //console.log(fator);
    
  }
}
